/* עיצוב סכומים ותאריכים לתצוגה */

export const MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
export const DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];

/* סכום מוצג כיחידה משמאל לימין (LRI...PDI), יחד עם הסימן שלו. בלי זה, בטקסט עברי
   המינוס קופץ לצד השני: "₪1,514-" במקום "-₪1,514" */
const ltr = (s) => '⁦' + s + '⁩';
const pick = (sign, n) => (sign != null && sign !== '' ? sign : n < 0 ? '-' : '');

/** ₪1,234.50. בלי סימן, אלא אם נשלח sign ('+', '-', '−') */
export function fmt(n, sign = '') {
  return ltr(sign + '₪' + Math.abs(Number(n) || 0).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
}
/** -₪1,234.50 */
export function fmtSigned(n) {
  return fmt(n, n < 0 ? '-' : '');
}
/** -₪1,235 (מעוגל לשקל). sign מחליף את הסימן */
export function fMoney(n, sign) {
  return ltr(pick(sign, n) + '₪' + Math.abs(Math.round(Number(n) || 0)).toLocaleString('he-IL'));
}
/** ₪1.2K */
export function fShort(n, sign) {
  const a = Math.abs(Math.round(n));
  const s = a >= 1000 ? (a / 1000).toFixed(a >= 10000 ? 0 : 1).replace('.0', '') + 'K' : String(a);
  return ltr(pick(sign, n) + '₪' + s);
}
/** +₪120 / -₪120 */
export function signed(x) {
  x = Math.round(x);
  return fMoney(x, x > 0 ? '+' : '');
}
/** ₪ בלי סימן מינוס (או עם הסימן שנשלח) */
export function abs$(n, sign) {
  return fMoney(Math.abs(n), sign);
}

/* ── תאריכים ── */
export function fISO(d) {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
export function todayISO() {
  return fISO(new Date());
}
/** היום בצהריים. חישובי ימים נעשים בצהריים כדי שמעבר שעון לא יזיז יום */
export function t0() {
  return new Date(todayISO() + 'T12:00:00');
}
export function toDate(x) {
  return x instanceof Date ? x : new Date(String(x).slice(0, 10) + 'T12:00:00');
}
export function fDim(y, m) {
  return new Date(y, m + 1, 0).getDate();
}
/** הפרש ימים קלנדרי, עמיד למעבר שעון קיץ/חורף */
export function dDays(a, b) {
  a = toDate(a);
  b = toDate(b);
  return Math.round(
    (new Date(a.getFullYear(), a.getMonth(), a.getDate(), 12) - new Date(b.getFullYear(), b.getMonth(), b.getDate(), 12)) / 864e5,
  );
}
export function addDays(d, n) {
  const x = new Date(toDate(d).getTime());
  x.setDate(x.getDate() + n);
  return x;
}
/** 10.10 */
export function wD(x) {
  x = toDate(x);
  return x.getDate() + '.' + (x.getMonth() + 1);
}
/** 10.10, ועם שנה כשהיא לא השנה הנוכחית: 10.10.27 */
export function wDY(x) {
  x = toDate(x);
  return wD(x) + (x.getFullYear() !== new Date().getFullYear() ? '.' + String(x.getFullYear()).slice(2) : '');
}
/** 10.10.26 */
export function wDYY(x) {
  x = toDate(x);
  return wD(x) + '.' + String(x.getFullYear()).slice(2);
}
export function iso10(s) {
  return String(s || '').slice(0, 10);
}

export function median(a) {
  if (!a.length) return 0;
  a = a.slice().sort((x, y) => x - y);
  const m = Math.floor(a.length / 2);
  return a.length % 2 ? a[m] : (a[m - 1] + a[m]) / 2;
}
export function cents(v) {
  return Math.round(Math.abs(Number(v) || 0) * 100);
}
export function absAmt(t) {
  return Math.abs(Number(t.amount) || 0);
}
